export function getDefaultBrowserLanguage(supportedLangs) {
    const supportedLangsLower = supportedLangs.map((supportedLang) => supportedLang.toLowerCase());
    const preferredLanguage = extractlanguage(navigator.language ?? '');
    if (supportedLangsLower.includes(preferredLanguage))
        return preferredLanguage;
    const allBrowserLanguages = navigator.languages?.map((browserLang) => extractlanguage(browserLang)) || [];
    const foundLanguage = allBrowserLanguages.find((browserLang) => {
        return supportedLangsLower.includes(browserLang);
    });
    return foundLanguage ?? 'en';
}
function extractlanguage(language) {
    if (language.includes('-')) {
        const langAndLocal = language.split('-');
        return langAndLocal[0].toLowerCase();
    }
    return language.toLowerCase();
}
